import React from "react";
import Icon from 'components/Safra/Icon';
import { SwapButtonRoot } from "./styles";

export default function SwapButton({
  onClick,
  disabled = false,
  ariaLabel = "Inverter origem e destino",
}) {
  return (
    <SwapButtonRoot type="button" onClick={onClick} disabled={disabled} aria-label={ariaLabel}>
      <Icon name="arrow-up-down" size={16} color="white" />
    </SwapButtonRoot>
  );
}
